import "core-js/modules/es.array.push.js";
import { $h, Tips, basePost, U, baseGet, URL, SplitArray, urlParams } from '@/utils/util.js';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import axios from 'axios';
import store from '@/store';
import router from '@/router';
export default {
  props: {
    xzlag: {
      type: Number,
      value: 1
    }
  },
  data() {
    return {
      peizhiinfo: {}
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // 平滑滚动效果
      });
    },
    //进入到新闻列表
    goxwlist: function (id, xzmenu) {
      var that = this;
      router.push({
        path: '/newslist',
        query: {
          id: id,
          xzmenu: xzmenu
        }
      });
    },
    //进入到具体的新闻内容
    goxinwen: function (id, xzmenu) {
      var that = this;
      router.push({
        path: '/newsdetail',
        query: {
          id: id,
          xzmenu: xzmenu,
          xzlag: that.xzlag
        }
      });
    },
    //基本配置
    getpeizhi: function () {
      var that = this;
      var url = U({
        m: 'zrcwebapi',
        c: 'webpublic_api',
        a: 'getpeizhi'
      }, URL);
      baseGet(url, function (res) {
        that.peizhiinfo = res.data.info.peizhiinfo;
      });
    }
  },
  mounted: function () {
    var that = this;
    that.getpeizhi(); //基本配置
  }
};